import Vue, { computed } from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
import axios from 'axios'
import './plugins/vuetify-money.js'

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
Vue.use(require('vue-moment'))
Vue.filter('prettyBytes', function (num) {
	// jacked from: https://github.com/sindresorhus/pretty-bytes
	if (typeof num !== 'number' || isNaN(num)) {
		throw new TypeError('Expected a number')
	}

	var exponent
	var unit
	var neg = num < 0
	var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	if (neg) {
		num = -num
	}

	if (num < 1) {
		return (neg ? '-' : '') + num + ' B'
	}

	exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
	num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
	unit = units[exponent]

	return (neg ? '-' : '') + num + ' ' + unit
})

new Vue({
	router,
	vuetify,
	store: store,
	render: h => h(App),
	data () {
		return {
			currentRoute: null
		}
	},
	created () {
		const userInfo = localStorage.getItem('user')
		if (userInfo) {
			try {
				if (!router.history._startLocation.startsWith('/verify-email')) {
					router.push('/dashboard')
				}
				const userData = JSON.parse(userInfo)
				this.$store.commit('auth/setUserData', userData)
			} catch (e) {

			}
		}
		axios.interceptors.response.use(
			response => response,
			error => {
				if (error.response.status === 401) {
					// this.$store.dispatch('logout')
				}
				return Promise.reject(error)
			}
		)
	}
}).$mount('#app')
